export const SIGNALING_URL = import.meta.env.VITE_SIGNALING_URL || "https://be.share-anywhere.com";
export const PUBLIC_APP_URL = import.meta.env.VITE_PUBLIC_APP_URL || "https://share-anywhere.com";

// Public STUN endpoints discover a direct route. TURN relay credentials are short-lived and
// come from the signaling server per session (see loadIceServers in signaling.ts).
export const ICE_SERVERS: RTCIceServer[] = [
  { urls: ["stun:stun.l.google.com:19302", "stun:stun1.l.google.com:19302"] },
];
